// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import type { Theme } from '../../../types';
import { media } from '../../../helpers';
import ButtonComponent from '../../button';

type Props = {|
  onClick: Function,
  disabled: boolean,
  removeFiltersButtonText: string,
|};

const Button = styled<typeof ButtonComponent, Theme, _>(ButtonComponent)`
  display: none;
  ${media.sm(css`
    display: block;
  `)}
  && {
    padding: 0;
    margin: 0;
    align-self: center;
  }
`;

const RemoveFiltersButton = ({
  onClick,
  disabled,
  removeFiltersButtonText,
}: Props) => (
  <Button disabled={disabled} variant="link_text" onClick={onClick}>{removeFiltersButtonText}</Button>
);

export default RemoveFiltersButton;
